module.exports = __webpack_public_path__ + "static/media/namecard-with-name@2x.b5dd0ef9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles/namecard-with-name@2x.png
// module id = 1063
// module chunks = 49